import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './shared/i18n/en';
import pt from './shared/i18n/pt';
import es from './shared/i18n/es';
import { langStorageIndex } from './shared/contexts/AppContextProvider';

// the translations
// (tip move them in a JSON file and import them)
const resources = { pt, en, es };

const storedLang = localStorage.getItem(langStorageIndex);
if (storedLang && storedLang.includes('-')) {
    const baseLang = storedLang.split('-')[0];
    localStorage.setItem(langStorageIndex, baseLang.toLowerCase());
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
        lng: navigator.language.split('-')[0],
        ns: ['translation'],
        load: 'languageOnly',
        detection: {
            order: ['localStorage', 'navigator'],
            lookupQuerystring: 'lng',
            lookupLocalStorage: langStorageIndex,
        },
        whitelist: ['en', 'pt', 'es'],
        fallbackLng: process.env.DEFAULT_LANGUAGE || 'pt',
        resources,
        returnEmptyString: false,
        keySeparator: '.', // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
